import { useGameStore } from '../../store/gameStore';
import { HumanRoundHistorySection } from './HumanRoundHistorySection';

export function SettlementModal() {
  const game = useGameStore((s) => s.game);
  const { phase, players, finalScores, winners } = game;

  if (phase !== 'game_over') return null;

  const ranked = players
    .map((p, index) => ({
      ...p,
      index,
      score: finalScores[index] ?? p.chips,
    }))
    .sort((a, b) => b.score - a.score);

  return (
    <div className="overlay-panel mx-auto max-w-sm p-4">
      <h2 className="text-lg font-bold text-amber-100">최종 결과</h2>
      <ul className="mt-3 space-y-2">
        {ranked.map((player, rank) => (
          <li
            key={player.index}
            className="flex items-center justify-between rounded-xl bg-white/5 px-3 py-2 text-sm"
          >
            <span>
              {rank + 1}위 · {player.name}
              {player.isHuman ? ' (나)' : ''}
            </span>
            <span className="font-semibold text-amber-300">{player.score}점</span>
          </li>
        ))}
      </ul>
      {winners.length > 0 && (
        <p className="mt-3 text-center text-sm text-amber-100">
          우승: {winners.map((i) => players[i]?.name).join(', ')}
        </p>
      )}
      <HumanRoundHistorySection className="mt-4 max-h-48 overflow-y-auto" />
    </div>
  );
}
